/**
 * @template T
 */
export class AsyncCache {
  constructor () {
    /** @type {Map<string, Promise<T>>} */
    this.cache = new Map()
  }

  /** @param {string} key */
  async get (key) {
    if (this.cache.has(key)) {
      return this.cache.get(key)
    }

    const promise = this.fetch(key)
    this.cache.set(key, promise)

    return promise
  }

  /** @param {string} key */
  async fetch (key) {}
}

/**
 * @extends {AsyncCache<string>}
 */
class PreOrderRequestFormCache extends AsyncCache {
  /** @param {string} handle */
  async fetch (handle) {
    const response = await fetch(
      `/products/${handle}?section_id=product-pre-order-request-form`,
    )

    return response.text()
  }
}

/**
 * @extends {AsyncCache<string>}
 */
class ProductBundleDrawerCache extends AsyncCache {
  /** @param {string} handle */
  async fetch (handle) {
    const response = await fetch(
      `/products/${handle}?section_id=template-product`,
    )

    return response.text()
  }
}

window.BAO = window.BAO || {}
window.BAO.Caches = {
  preOrderRequestFormCache: new PreOrderRequestFormCache(),
  productBundleDrawerCache: new ProductBundleDrawerCache(),
}
